module.exports = __webpack_public_path__ + "img/share-plain-icon.3399db90.svg";